export default __webpack_public_path__ + "static/media/LaserCutterImg.f3210914.jpg";